(function (w, d) {
	w = w || window;
	d = d || document;
	// <!-- Global site tag (gtag.js) - Google Analytics -->
	(function (w, d, t, u) {
		var s = d.createElement(t);
		s.async = 1;
		s.src = u;
		w.dataLayer = w.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}

		gtag('js', new Date());

		gtag('config', 'G-0G4LK2LFGZ');
		gtag('config', 'G-EWVJVMTQHK');
	})(w, d, 'script', 'https://www.googletagmanager.com/gtag/js?id=G-0G4LK2LFGZ');
	//   <!-- /Yandex.Metrika counter -->
	(function (m, e, t, r, i, k, a) {
		m[i] =
			m[i] ||
			function () {
				(m[i].a = m[i].a || []).push(arguments);
			};
		m[i].l = 1 * new Date();
		(k = e.createElement(t)), (a = e.getElementsByTagName(t)[0]), (k.async = 1), (k.src = r), a.parentNode.insertBefore(k, a);
	})(w, d, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

	ym(67019512, 'init', {
		clickmap: true,
		trackLinks: true,
		accurateTrackBounce: true,
	});
})(window, document);
